import { Skeleton } from "@mui/material"

export const SelectionPlaceholder = () => (
    <div className="aspect-square relative rounded-lg flex justify-center items-center md:p-2 md:px-6 px-2 md:w-28 w-20 shrink-0">
        <Skeleton variant="rounded" width="100%" height="100%" />
    </div>
)
